import React from "react";
import { NavDropdown } from "react-bootstrap";
import NavBarKidsOnBikes from "../../../assets/kids-on-bikes/navbar-icon-kids-on-bikes.webp";

const sessionLinks = [
  {
    href: "/kids-on-bikes-turnaround-rock-session-05",
    label: "Turnaround Rock: Session 05: 05-31-2024",
  },
  {
    href: "/kids-on-bikes-turnaround-rock-session-04",
    label: "Turnaround Rock: Session 04: 05-04-2024",
  },
  {
    href: "/kids-on-bikes-turnaround-rock-session-03",
    label: "Turnaround Rock: Session 03: 02-16-2024",
  },
  {
    href: "/kids-on-bikes-turnaround-rock-session-02",
    label: "Turnaround Rock: Session 02: 01-19-2024",
  },
  {
    href: "/kids-on-bikes-turnaround-rock-session-01",
    label: "Turnaround Rock: Session 01: 01-05-2024",
  },
  {
    href: "/kids-on-bikes-turnaround-rock-session-00",
    label: "Turnaround Rock: Session 00: 12-22-2023",
  },
];

const renderLinks = (links) =>
  links.map((item) => (
    <NavDropdown.Item key={item.href} href={item.href}>
      {item.label}
    </NavDropdown.Item>
  ));

const KidsOnBikesNavBar = () => {
  return (
    <NavDropdown title="Kids on Bikes" id="kids-on-bikes-nav-dropdown">
      <NavDropdown.Header>
        <img
          src={NavBarKidsOnBikes}
          alt="Kids On Bikes"
          style={{ maxHeight: 85 }}
        />
      </NavDropdown.Header>

      <NavDropdown title="Sessions" id="kids-on-bikes-sessions-dropdown">
        {renderLinks(sessionLinks)}
      </NavDropdown>
    </NavDropdown>
  );
};

export default KidsOnBikesNavBar;
